import * as z from 'zod';

export const organizationTypeQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type OrganizationTypeQueryLinkerSchema = z.infer<typeof organizationTypeQueryLinkerSchema>;
